import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment.js";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const FollowUp = ({ history, match, props }) => {
  const [dap_users, setUsers] = useState([]);
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [billable, setBillable] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [postcity, setPostCity] = useState("");
  const [poststate, setPostState] = useState("");
  const [toggleChecked, setToggleChecked] = useState(false);
  const [loader, setLoader] = useState(true);
  const [showAddNote, setShowAddNote] = useState(false);

  // const dap_id = match.params.id;
  const toggle = (e) => {
    setToggleChecked(true);
  };
  useEffect(() => {
    let lead_executive_id = "";
    if (localStorage.getItem("isLeadExecutive")) {
      lead_executive_id = JSON.parse(
        localStorage.getItem("executivedetails")
      )._id;
    } else {
    }
    axios
      .post(environment.dap_url + "crm_api/getFollowUpLeadsByLeadExecutiveId", {
        lead_executive_id: lead_executive_id,
      })
      .then((res) => {
        // const dap_users = res.data;
        // console.log("hii");
        console.log("result", res.data);
        setUsers(res.data);
        // console.log(res.data);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const getFollowUpCount = (id) => {
    // console.log(id);
    axios
      .post(environment.dap_url + "crm_api/countFollowUp", {
        lead_executive_id: "637ca87cfd5c33088045d1f9",
        lead_id: id,
      })
      .then((res) => {
        console.log(res.data);
        return res.data;
      })
      .catch(function (error) {
        console.log(error);
        return "";
      });
  };

  const deleteHandler = (id) => {
    // console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "crm_api/DeleteLeads?Id=" + id)
          .then((res) => {
            console.log(res);
            MySwal.fire({
              title: <p>Lead has been successfully deleted!</p>,
              type: "success",
            });
            //history.push("/customers");
            axios
              .get(environment.dap_url + "crm_api/getAllActiveLeads")
              .then((res) => {
                setUsers(res.data);
              })
              .catch((err) => {});
          })
          .catch((err) => {
            MySwal.fire({
              title: (
                <p>{err?.response?.data?.message || "Lead deletion failed"}</p>
              ),
              type: "error",
            });
          });
      }
    });
  };

  const columns = [
    {
      dataField: "sl.no",
      text: "Sl no.",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "details[0]",
      text: "Name",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        console.log("details", cell);
        return cell.userFirstName + " " + cell.userLastName;
        // return dap_users[rowIndex].details[0].userFirstName+" "+dap_users[rowIndex].details[0].userLastName
      },
    },
    {
      dataField: "details[0].package",
      text: "Package",
      sort: true,
    },
    {
      dataField: "details[0].email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "details[0].phone",
      text: "Phone no.",
      sort: true,
    },

    {
      dataField: "followup",
      text: "Follow up",
      sort: true,
    },
    {
      dataField: "startFollowUp",
      text: "Start Follow Up",
      sort: true,
      formatter: (dataField) => {
        // let dateTimeArr = dataField.split("T");
        let dateArr = dataField.split("-");
        let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return dateFinal;
      },
    },
    {
      dataField: "lastFollowUp",
      text: "Last Follow Up",
      sort: true,
      formatter: (dataField) => {
        let dateArr = dataField.split("-");
        let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return dateFinal;
      },
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            {/* <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(dataField)}
            >
              Delete <i className="fa fa-trash-o"></i>
            </Button>
            <LinkContainer to={`/subscriptions/edit/` + dataField}>
              <Button variant="info" className="btn-sm">
                Edit <i className="fa fa-edit "></i>
              </Button>
            </LinkContainer> */}
            <LinkContainer to={`/followup-history/` + dataField}>
              <Button variant="light" className="btn-sm">
                View History<i className="fa fa-eye"></i>
              </Button>
            </LinkContainer>
          </div>
        );
      },
    },

    // {
    //   dataField: "_id",
    //   text: "Delete",
    //   sort: false,
    //   formatter: (dataField) => {
    //     return (
    //       <div>
    //         <Button
    //           variant="danger"
    //           className="btn-sm"
    //           onClick={() => deleteHandler(dataField)}
    //         >
    //           Delete <i className="fa fa-trash-o"></i>
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  return (
    <div class="container-fluid">
      <NavbarNew />
      <div className="row">
        <div className="col-12">
          <div className="card-body">
            <h4 className="card-title">FOLLOW UPs</h4>
            <div className="row">
              <div className="col-12">
                <ToolkitProvider
                  keyField="id"
                  bootstrap4
                  data={dap_users}
                  columns={columns}
                  search
                >
                  {(props) => (
                    <div>
                      <div className="d-flex align-items-center">
                        <p className="mb-2 mr-2">Search in table:</p>
                        <SearchBar {...props.searchProps} />
                      </div>
                      <BootstrapTable
                        defaultSorted={defaultSorted}
                        pagination={paginationFactory()}
                        {...props.baseProps}
                        wrapperClasses="table-responsive"
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FollowUp;
